/* Attribution and analytics events, loaded on EVERY page (home included, on purpose: most visits and campaign links land on "/").
   - Any rep / affiliate / campaign parameter in the address is remembered for 30 days and attached to the cart as an attribute,
     so it is printed on the order. Shopify Collabs links keep working exactly as before.
   - window.wbTrack(name, data) announces a custom event "wb_<name>" (add_to_cart, lead) with that journey, for Shopify Customer events
     and Google Tag Manager. It never blocks or delays anything and never carries a name, email or phone. */
(function () {
  'use strict';

  /* ---- rep / affiliate attribution -------------------------------------------------------------
     Any of these URL parameters is remembered for 30 days and attached to the cart as an attribute,
     so it is printed on the order. Shopify Collabs links keep working exactly as before. */
  var KEYS = ['ref', 'rep', 'sales_rep', 'affiliate', 'utm_source', 'utm_medium', 'utm_campaign',
    /* on-site journey, added by WinBoost's own links: where the click came from, which block, which item, which business */
    'wb_from', 'wb_section', 'wb_item', 'wb_industry'];
  var STORE = 'wb_attribution';

  /* ---- the visitor's cookie choices (Québec Law 25, GDPR) ---------------------------------------------------------------
     Read from Shopify's Customer Privacy API, which follows Shopify's cookie banner. Where no choice is needed, Shopify answers "allowed".
     Until marketing is allowed, the rep / affiliate / campaign link is kept for this visit only (sessionStorage), never for 30 days;
     until analytics is allowed, nothing is pushed to Google Tag Manager's dataLayer. Shopify's own Customer events apply the choices themselves. */
  var consent = { ready: false, analytics: false, marketing: false }, waiting = [];
  function setConsent(a, m) {
    consent.ready = true; consent.analytics = !!a; consent.marketing = !!m;
    if (consent.marketing) persist();
    var w = waiting; waiting = [];
    if (consent.analytics) w.forEach(function (x) { try { (window.dataLayer = window.dataLayer || []).push(x); } catch (e) {} });
  }
  function readConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      setConsent(cp.analyticsProcessingAllowed(), cp.marketingAllowed());
      return true;
    } catch (e) { return false; }
  }
  (function loadConsent() {
    if (readConsent()) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) readConsent(); });
      } else if (!window.Shopify || !window.Shopify.shop) {
        setConsent(true, true);   /* not on Shopify (local preview): nothing to ask */
      }
    } catch (e) {}
  })();
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    setConsent(d.analyticsAllowed, d.marketingAllowed);
  });

  function readStore(s) { try { return JSON.parse(s.getItem(STORE) || '{}'); } catch (e) { return {}; } }
  function read() {
    var kept = {}; try { kept = readStore(localStorage); } catch (e) {}
    var visit = {}; try { visit = readStore(sessionStorage); } catch (e) {}
    if (kept.t && Date.now() - kept.t > 30 * 864e5) kept = {};
    return (visit.t || 0) >= (kept.t || 0) && visit.t ? visit : kept;
  }
  /* the journey of this visit is kept 30 days once marketing cookies are allowed */
  function persist() {
    try { var v = readStore(sessionStorage); if (v.t) localStorage.setItem(STORE, JSON.stringify(v)); } catch (e) {}
  }
  (function capture() {
    var q = new URLSearchParams(location.search), found = false, cur = read();
    /* a new on-site journey replaces the previous one (never mixes a block of one link with the business of another) */
    var journey = KEYS.filter(function (k) { return k.indexOf('wb_') === 0; });
    if (journey.some(function (k) { return q.get(k); })) journey.forEach(function (k) { delete cur[k]; });
    KEYS.forEach(function (k) { if (q.get(k)) { cur[k] = q.get(k); found = true; } });
    if (found) {
      cur.t = Date.now();
      try { sessionStorage.setItem(STORE, JSON.stringify(cur)); } catch (e) {}
      if (consent.marketing) persist();
    }
  })();
  window.wbAttribution = function () {
    var cur = read(), out = {};
    KEYS.forEach(function (k) { if (cur[k]) out[k] = cur[k]; });
    return out;
  };

  /* ---- counting add-to-carts ----------------------------------------------------------------------
     Shopify counts add-to-carts itself (Analytics > Reports > Online store conversion). This adds the detail: every add to cart (product
     page, collection tiles) is also announced as the custom event "wb_add_to_cart" with the visitor's journey (wb_from, wb_section, wb_item,
     utm...), for Shopify Customer events and Google Tag Manager. It never blocks or delays the purchase. */
  window.wbTrack = function (name, data) {
    var payload = {}, a = window.wbAttribution ? window.wbAttribution() : {};
    Object.keys(a).forEach(function (k) { payload[k] = a[k]; });
    Object.keys(data || {}).forEach(function (k) { payload[k] = data[k]; });
    payload.page = location.pathname;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('wb_' + name, payload); } catch (e) {}
    var dl = Object.assign({ event: 'wb_' + name }, payload);
    if (consent.ready) { if (consent.analytics) { try { (window.dataLayer = window.dataLayer || []).push(dl); } catch (e) {} } }
    else if (waiting.length < 50) waiting.push(dl);
  };

  /* ---- "Cookie preferences" in the footer opens the preferences of Shopify's cookie banner -----------------------------
     The link stays hidden (CSS) until the banner is switched on in Shopify (Settings > Customer privacy > Cookie banner). */
  (function cookieLink() {
    var tries = 0;
    (function look() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { document.documentElement.classList.add('wb-cookie-banner'); return; }
      if (++tries < 30) setTimeout(look, 500);
    })();
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href$="#cookie-preferences"]');
      if (!a || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
      e.preventDefault();
      try { window.privacyBanner.showPreferences(); } catch (x) {}
    });
  })();

  /* ---- everything else a visitor does -----------------------------------------------------------------------------------------
     One delegated listener per kind of action, so every component on every page is covered without touching the design.
     Events (all prefixed wb_): buy_click, consultant_click, collection_click, outbound_click, call_tap, demo_play, demo_complete,
     form_start, checkout_click, scroll (25/50/75/90 percent), plus add_to_cart and lead announced by their own code.
     Only labels, section ids and addresses are sent: never anything a visitor typed. */
  function label(el) { return String((el && (el.getAttribute('aria-label') || el.textContent)) || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  function param(href, k) { try { return new URL(href, location.href).searchParams.get(k) || ''; } catch (e) { return ''; } }
  /* the nearest named block the element sits in (skips the generic page containers) */
  function where(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentNode) if (n.id && n.id !== 'root' && n.id !== 'MainContent') return n.id;
    return '';
  }

  document.addEventListener('click', function (e) {
    try {
      var el = e.target && e.target.closest && e.target.closest('a[href], button[name="checkout"]');
      if (!el) return;
      var href = el.getAttribute('href') || '', t = { label: label(el), section: where(el) };
      if (!href) { window.wbTrack('checkout_click', t); return; }
      if (href.slice(0, 4) === 'tel:') { t.via = 'link'; window.wbTrack('call_tap', t); return; }
      var u; try { u = new URL(href, location.href); } catch (x) { return; }
      if (u.host !== location.host) { t.host = u.host; window.wbTrack('outbound_click', t); return; }
      if (/^[/]products[/]/.test(u.pathname)) { t.product = u.pathname.split('/')[2]; t.from = param(href, 'wb_from'); t.item = param(href, 'wb_item'); window.wbTrack('buy_click', t); return; }
      if (/^[/]collections[/]/.test(u.pathname)) { window.wbTrack('collection_click', t); return; }
      if (u.hash === '#final-form' || /^[/]pages[/]contact/.test(u.pathname)) window.wbTrack('consultant_click', t);
    } catch (x) {}
  }, true);

  /* tap-to-talk on the orbit opens the phone through window.open('tel:...') rather than a link */
  var open0 = window.open;
  window.open = function (u) {
    try { if (typeof u === 'string' && u.slice(0, 4) === 'tel:') window.wbTrack('call_tap', { via: 'orbit', section: 'tap-to-talk' }); } catch (x) {}
    return open0.apply(this, arguments);
  };

  /* demo calls: the page's own audio players (a pause then resume is not a new play) */
  function rec(a) { return String(a.currentSrc || a.src || '').split('?')[0].split('/').pop(); }
  document.addEventListener('play', function (e) {
    var a = e.target; if (a && a.tagName === 'AUDIO' && a.currentTime < 0.5) window.wbTrack('demo_play', { recording: rec(a) });
  }, true);
  document.addEventListener('ended', function (e) {
    var a = e.target; if (a && a.tagName === 'AUDIO') window.wbTrack('demo_complete', { recording: rec(a) });
  }, true);

  /* a visitor starts filling one of the lead forms (once per form per page) */
  var started = {};
  document.addEventListener('focusin', function (e) {
    try {
      var f = e.target && e.target.closest && e.target.closest('form');
      if (!f || !f.querySelector('input[type="email"], input[name*="email"]')) return;
      var key = where(f) || f.getAttribute('action') || 'form';
      if (started[key]) return; started[key] = 1;
      window.wbTrack('form_start', { source: key });
    } catch (x) {}
  });

  /* how far down the page the visitor read */
  var marks = [25, 50, 75, 90], reached = {}, raf = 0;
  function depth() {
    raf = 0;
    var d = document.documentElement, room = d.scrollHeight - window.innerHeight;
    if (room <= 0) return;
    var pct = (window.pageYOffset || d.scrollTop || 0) / room * 100;
    marks.forEach(function (m) { if (pct >= m && !reached[m]) { reached[m] = 1; window.wbTrack('scroll', { percent: m }); } });
  }
  window.addEventListener('scroll', function () { if (!raf) raf = window.requestAnimationFrame(depth); }, { passive: true });

})();
